<template>
  <div class="breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/events' }"
        >会议活动</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ eventDesc.name }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {},
  computed: {
    eventDesc: {
      get() {
        return this.$store.state.toGetCurrentEvent.currentEvent;
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
